<template>
  <div v-if="remetente">
    <CenarioInput
      tipo="cnae"
      :options="listaCnaeRemetente"
      placeholder="Selecione uma CNAE"
      :model="cnaeRemetente"
      :loading="carregandoAlgumaCnae"
      :clickCnae="handleClickCnae"
      @update:model="update => (cnaeRemetente = update)"
      @selected="update => updateDados(update.label, 'cnaeRemetente', listaCnaeRemetente)"
      :validaCampos="validaCampos"
      :exibeValidacao="exibeValidacao"
      nome="cnaeRemetente"
    />
    <AlertaCenario
      v-if="cnaeSelecionadaRemetente && cnaeSelecionadaRemetente.ncm_indireta == 1"
      :alerta="'Esta CNAE não está vinculada a NCM selecionada.'"
    />
    <AlertaCenario
      v-if="
        cnaeSelecionadaRemetente &&
          cnaeSelecionadaRemetente.ncm_indireta == 0 &&
          cnaeSelecionadaRemetente.ncm_direta == 0
      "
      :alerta="'Esta CNAE não está vinculada com nenhuma NCM pesquisada.'"
    />
    <AlertaCenario v-if="alertaCnae && dadosForm.ncm && !carregandoCnae" :alerta="alertaCnae" />
  </div>
  <div v-else>
    <CenarioInput
      tipo="cnae"
      :options="listaCnaeDestinatario"
      placeholder="Selecione uma CNAE"
      :model="cnaeDestinatario"
      :loading="carregandoAlgumaCnae"
      :clickCnae="handleClickCnae"
      @update:model="update => (cnaeDestinatario = update)"
      @selected="update => updateDados(update.label, 'cnaeDestinatario', listaCnaeDestinatario)"
      :validaCampos="validaCampos"
      :exibeValidacao="exibeValidacao"
      nome="cnaeDestinatario"
    />
    <AlertaCenario
      v-if="cnaeSelecionadaDestinatario && cnaeSelecionadaDestinatario.ncm_indireta == 1"
      :alerta="'Esta CNAE não está vinculada a NCM selecionada.'"
    />
    <AlertaCenario
      v-if="
        cnaeSelecionadaDestinatario &&
          cnaeSelecionadaDestinatario.ncm_indireta == 0 &&
          cnaeSelecionadaDestinatario.ncm_direta == 0
      "
      :alerta="'Esta CNAE não está vinculada com nenhuma NCM pesquisada.'"
    />
    <AlertaCenario
      v-if="alertaCnae && dadosForm.ncm && !carregandoAlgumaCnae"
      :alerta="alertaCnae"
    />
  </div>
</template>

<script>
import AlertaCenario from "./AlertaCenario.vue";
import Api from "@/services/api.js";
import CenarioInput from "../CenarioInput/CenarioInput.vue";

export default {
  name: "CenarioInputCnae",
  components: { AlertaCenario, CenarioInput },
  props: {
    id: Number,
    calculaDadosForm: Function,
    calculaDados: Function,
    setAtividadeOptionsRem: Function,
    setAtividadeOptionsDes: Function,
    dadosForm: Object,
    filtros: Object,
    payloadCnae: Object,
    cnaeRemetenteLista: Array,
    cnaeDestinatarioLista: Array,
    openModalCnaeCompreende: Function,
    remetente: Boolean,
    destinatario: Boolean,
    elementoCriado: Boolean,
    carregandoAlgumaCnae: Boolean,
    validaCampos: Object,
    exibeValidacao: Boolean
  },
  inject: ["existeLoading", "setElementoCriado", "setTrava"],
  data() {
    return {
      elementoCriadoCnae: false,
      // listaCnaeRemetente: [],
      // listaCnaeDestinatario: [],
      cnaeRemetente: "",
      cnaeDestinatario: "",
      carregandoCnae: false,
      alertaCnae: "",
      ultimoCnpj: null
    };
  },
  async created() {
    this.carregandoCnae = false;
    this.calculaDados(false, "carregandoAlgumaCnae");

    if (this.carregandoAlgumaCnae) {
      await new Api().cancel(this.id);
    }
    if (this.remetente && this.elementoCriado == false) {
      this.existeLoading(true);
      await this.obtemCnae();
      this.setElementoCriado(true);
    } else if (this.dadosForm.tipoOperacao == 41 || this.remetente) {
      await this.obtemCnae();
    }
    this.carregaDadosForm();
  },
  watch: {
    cnaeRemetente() {
      if (typeof this.cnaeRemetente == "string") {
        this.calculaDados(this.cnaeRemetente, "cnaeRemetenteLabel");
      }
    },
    cnaeDestinatario() {
      if (typeof this.cnaeDestinatario == "string") {
        this.calculaDados(this.cnaeDestinatario, "cnaeDestinatarioLabel");
      }
    },
    payloadCnae: {
      deep: true,
      async handler(newVal, oldVal) {
        const cnpjAtual = (newVal && newVal.empresaR) || (newVal && newVal.empresaD);

        // Se o CNPJ mudou, permite nova consulta
        if (cnpjAtual && cnpjAtual !== this.ultimoCnpj) {
          this.ultimoCnpj = cnpjAtual;
        } else if (JSON.stringify(newVal) == JSON.stringify(oldVal)) {
          return;
        }

        this.$nextTick(async () => {
          if (["", "39", "40", "46"].includes(this.dadosForm.tipoOperacao) && this.remetente) {
            await this.obtemCnae();
          } else if (this.dadosForm.tipoOperacao == 41 && this.destinatario) {
            await this.obtemCnae();
          }
        });
      }
    },
    dadosForm: {
      deep: true,
      async handler() {
        // await this.$nextTick(() => {
        //   this.obtemCnae();
        // });
        await this.$nextTick(() => {
          this.carregaDadosForm();
        });
      }
    }
  },
  computed: {
    listaCnaeRemetente() {
      return this.cnaeRemetenteLista ? this.cnaeRemetenteLista : [];
    },
    listaCnaeDestinatario() {
      return this.cnaeDestinatarioLista ? this.cnaeDestinatarioLista : [];
    },
    cnaeSelecionadaRemetente() {
      let cnae = this.listaCnaeRemetente.find(p => p.value == this.dadosForm.cnaeRemetente);
      if (this.dadosForm.cnaeRemetente != "") {
        cnae && cnae.impedimento_sn == 0
          ? this.calculaDados(false, "impedimentoSnRes")
          : this.calculaDados(true, "impedimentoSnRes");

        if (cnae && cnae.id_atividade && cnae.id_atividade.length == 1) {
          this.calculaDadosForm(cnae.id_atividade[0], "atividadeRemetente");
          this.setAtividadeOptionsRem([]);
        } else if (cnae && !cnae.id_atividade) {
          this.calculaDadosForm("", "atividadeRemetente");
        } else {
          this.setAtividadeOptionsRem(cnae && cnae.id_atividade ? cnae.id_atividade : []);
        }

        return cnae;
      }
      this.setAtividadeOptionsRem([]);
      this.calculaDadosForm("", "atividadeRemetente");
      this.calculaDados(false, "impedimentoSnRes");
      return "";
    },
    cnaeSelecionadaDestinatario() {
      let cnae = this.listaCnaeDestinatario.find(p => p.value == this.dadosForm.cnaeDestinatario);
      if (cnae) {
        cnae.id_atividade.forEach((p, i) => {
          let atividade = p;
          if (["52", "53", "54", "55"].includes(p)) {
            atividade = "50";
          }
          if (["56", "57"].includes(p)) {
            atividade = "51";
          }
          cnae.id_atividade[i] = atividade;
        });
        cnae.id_atividade = cnae.id_atividade.filter((f, i, arr) => arr.indexOf(f) == i);
      }
      if (this.dadosForm.cnaeDestinatario != "" && this.dadosForm.sabeCNPJDestinatario == 1) {
        cnae && cnae.impedimento_sn == 0
          ? this.calculaDados(false, "impedimentoSnDes")
          : this.calculaDados(true, "impedimentoSnDes");

        if (cnae && cnae.id_atividade.length == 1) {
          this.calculaDadosForm(cnae.id_atividade[0], "atividadeDestino");
          this.setAtividadeOptionsDes([]);
        } else if (cnae && !cnae.id_atividade) {
          this.calculaDadosForm("", "atividadeDestino");
        } else {
          // this.calculaDadosForm("", "atividadeDestino");
          this.setAtividadeOptionsDes(cnae && cnae.id_atividade ? cnae.id_atividade : []);
        }

        return cnae;
      }
      if (this.dadosForm.sabeCNPJDestinatario == 1) {
        this.setAtividadeOptionsDes([]);
        this.calculaDadosForm("", "atividadeDestino");
        this.calculaDados(false, "impedimentoSnDes");
      }
      return "";
    }
  },
  methods: {
    async obtemCnae() {
      this.carregandoCnae = true;
      this.calculaDados(this.carregandoCnae, "carregandoAlgumaCnae");
      try {
        let response = await new Api().post(
          "Cnpj/getCnaesNew",
          this.payloadCnae,
          false,
          this.id
        );
        let listaCnae = {
          listaCnaeRemetente: response.dados.rem,
          listaCnaeDestinatario: response.dados.des
        };
        this.carregandoCnae = false;
        this.calculaDados(this.carregandoCnae, "carregandoAlgumaCnae");
        this.calculaDados(listaCnae, "listaCnae");
        this.alertaCnae = response.dados.alertaCnaeNcm;
        this.existeLoading(false);
      } catch (error) {}
    },
    handleClickCnae() {
      if (this.remetente) {
        this.openModalCnaeCompreende(this.cnaeSelecionadaRemetente);
      } else {
        this.openModalCnaeCompreende(this.cnaeSelecionadaDestinatario);
      }
    },
    carregaDadosForm() {
      let dados = [
        { valor: "cnaeRemetente", filtro: this.listaCnaeRemetente },
        { valor: "cnaeDestinatario", filtro: this.listaCnaeDestinatario }
        // { valor: "regimeRemetente", filtro: this.filtros.regime_tributacao.valores }
        // { valor: "atividadeRemetente", filtro: this.filtros.atividade.valores }
      ];
      dados.forEach(p => {
        this.carregaValor(p.valor, p.filtro);
      });
    },
    carregaValor(valor, filtro) {
      let resultado = filtro.find(p => p.value == this.dadosForm[valor]);
      this[valor] = resultado ? resultado.label : "";
    },
    updateDados(update, campo, caminho) {
      this[campo] = update;
      let valor = caminho.find(p => p.label == update);
      this.calculaDadosForm(valor ? valor.value : "", campo);
    }
    // async carregaAtividade() {
    //   await this.obtemAtividadeCnae();
    //   let atividade = {
    //     valor: "atividadeRemetente",
    //     filtro: this.filtros.atividade.valores
    //   };
    //   this.carregaValor(atividade.valor, atividade.filtro);
    // }
  }
};
</script>

<style lang="scss" scoped></style>
